import { createSelector } from 'reselect'

export const getLocationsLoading = createSelector(
  (state) => Boolean(state.geoObjects && state.geoObjects.locations && state.geoObjects.locations.isLoading),
  (isLoading) => isLoading
)
